import React, {Component} from 'react';
import {Grid, Loader, Container, Message} from 'semantic-ui-react';
import {connect} from 'react-redux';
import OrganizationAndSamProfileCard from 'go/components/common/OrganizationAndSamProfileCard';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import ApiActions from 'go/actions/api';
import {ORGANIZATION_PROFILE_TITLE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {CLEAR_ALL_MSG} from 'common/types';
import _ from 'lodash';
import {API_ORG_GET_BY_ID_SUCCESS} from 'common/types';
import {UnauthorizedPage} from 'go/pages/unauthorizedPage';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';

const ERROR = {
  SYSTEM: 'systemError',
  UNAUTH: 'unauthorizedUser',
};

// for dev only
export class OrgProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationContacts: [],
      isLoading: true,
      error: false,
    };
  }

  componentDidMount = () => {
    document.title = ORGANIZATION_PROFILE_TITLE;
    const orgId = this.props.match.params.id;
    this.initializeWithOrg(orgId);
  };

  componentWillUnmount = () => {
    this.props.clearAllMsg();
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.messages !== '' && nextProps.messages !== this.state.messages) {
      this.setState({messages: nextProps.messages});
    }
    if (_.get(nextProps, 'match.params.id') !== _.get(this.props, 'match.params.id')) {
      this.initializeWithOrg(_.get(nextProps, 'match.params.id'));
    }
  };

  handleListResponse = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      // unauthorized to view grants, or grant service is down
      return [];
    }
  };

  initializeWithOrg = (orgId) => {
    this.props
      .getOrganizationId(this.props.jwt, orgId)
      .then((response) => {
        if (response.type === API_ORG_GET_BY_ID_SUCCESS) {
          const {payload} = response;
          this.setState({isLoading: false, orgProfileDetails: payload});
          return payload;
        } else {
          return Promise.reject(ERROR.UNAUTH);
        }
      })
      .catch((error) => {
        this.handleError(error);
      });
  };

  handleError(errorCode) {
    this.setState({isLoading: false, error: errorCode});
  }

  render() {
    const {orgProfileDetails, isLoading, error} = this.state;
    const {messages} = this.props;

    return (
      <React.Fragment>
        {!error && (
          <Main>
            <Container>
              {messages && (
                <Message
                  positive={messages.indexOf('error') === -1}
                  negative={messages.indexOf('error') > 0}
                >
                  {messages}
                </Message>
              )}
              {isLoading ? (
                <Loader active>Loading...</Loader>
              ) : (
                <Grid stackable className="org-details-wrapper">
                  <Grid.Row>
                    <Grid.Column width="16">
                      <div class="sixteen wide column org-details">
                        <h2>{orgProfileDetails.displayName}</h2>
                      </div>
                      <h4 class="underlined-card-label">Organization information</h4>
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={12} className="sam-info-card">
                      <OrganizationAndSamProfileCard
                        mainLabel={'Organization information'}
                        data={orgProfileDetails}
                        isLoaded={!this.state.isLoading}
                        orgId={orgProfileDetails.organizationId}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )}
            </Container>
          </Main>
        )}
        {error && (error === ERROR.UNAUTH ? <UnauthorizedPage /> : <Error />)}
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  getOrganizationId: (token, orgId) => {
    const action = ApiActions.organization.getOrganizationById(token, orgId);
    const response = dispatch(action);
    return response;
  },
  clearAllMsg: () => {
    dispatch({type: CLEAR_ALL_MSG});
  },
});
export const mapStateToProps = (state) => {
  return {
    profile: state.profile,
    userId: state.auth.userId,
    jwt: state.auth.token,
    messages: state.messages.messages,
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgProfileContainer);
